import React, { useState } from "react";

// Drawer component (like an accordion with only one entry)
const Drawer = (props) => {
    const {title} = props;

    const [isOpen, setIsOpen] = useState(false);

    function toggleDrawer(e) {
        let content = e.target.closest('.drawer').querySelector('.drawer__content');
        let innerContent = content.querySelector('.drawer__inner-content');
        let targetHeight = isOpen ? 0 : innerContent.offsetHeight + 'px';
        
        // check if drawer is nested in another
        if (e.target.parentNode.parentNode.parentNode.closest('.drawer')) {
            let parentContent = e.target.parentNode.parentNode.parentNode.closest('.drawer').querySelector('.drawer__content');
            let parentInnerContent = parentContent.querySelector('.drawer__inner-content');
            let parentTargetHeight = isOpen ? (parentInnerContent.offsetHeight - innerContent.offsetHeight) + 'px' : (parentInnerContent.offsetHeight + innerContent.offsetHeight) + 'px';
            parentContent.style.height = parentTargetHeight;
        }
        
        content.style.height = targetHeight;

        setIsOpen(!isOpen);
    }

    return (
        <div className={`drawer ${isOpen && 'drawer--open'}`}>
            <div className="drawer__header" onClick={(e) => toggleDrawer(e)}>   
                <h6 className="drawer__title">{title}</h6>
                <button className={`drawer__toggle ${isOpen && 'drawer__toggle--open'}`}>
                    <i className="fa fa-chevron-down"></i>
                    <span className="sr-only">Toggle drawer</span>
                </button>
            </div>
            <div className="drawer__content">
                <div className="drawer__inner-content">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default Drawer;